// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__38z1N","title":"AfterFrontImage_title__1ZEnz"};